import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAffiliateUserStore } from '../../store/affiliate-user';

const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { isAuthenticated } = useAffiliateUserStore();

  // Check localStorage as fallback
  const hasTokenInStorage = localStorage.getItem('affiliateAccessToken');
  const hasUserInStorage = localStorage.getItem('affiliateUserData');

  const userIsAuthenticated =
    isAuthenticated || (hasTokenInStorage && hasUserInStorage);

  if (requireAuth) {
    // Protected route - require authentication
    if (!userIsAuthenticated) {
      return <Navigate to="/auth/login" replace />;
    }
    return children;
  } else {
    // Auth route - redirect if already authenticated
    if (userIsAuthenticated) {
      return <Navigate to="/dashboard" replace />;
    }
    return children;
  }
};

export default ProtectedRoute;
